import type {ReactNode} from "react";
import {Navigate} from "react-router-dom";
import type {FlowStep} from "../hooks/useFlowState";
import {useFlowState} from "../hooks/useFlowState";

type GuardedStepProps = {
    step: FlowStep;
    children: ReactNode;
};

export function GuardedStep({step, children}: GuardedStepProps) {
    const {canAccessStep, getNextStep} = useFlowState();

    if (!canAccessStep(step)) {
        const nextStep = getNextStep();
        return <Navigate to={`../${nextStep}`} replace />;
    }

    return <>{children}</>;
}
